import { ApiListResponse } from "types/api";

export const getEmptyListResponse = <T>(): ApiListResponse<T> => ({
  items: [],
  page: 1,
  pages: 1,
  count: 0,
});
